import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = `/team-member`;

export const inviteTeamMember = async (data) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/invite`,
    data,
    getAuthHeaders(),
  );
  return res.data;
};

export const getAllTeamMember = async () => {
  const res = await axiosInstance.get(`${BASE_URL}`, getAuthHeaders());
  return res.data;
};

export const removeTeamMember = async (uuid) => {
  const res = await axiosInstance.delete(
    `${BASE_URL}/${uuid}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const checkStatus = async (uuid) => {
  const res = await axiosInstance.get(`${BASE_URL}/check-status/${uuid}`);
  return res;
};

export const changeStatus = async (data) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/change-status`,
    data,
    getAuthHeaders(),
  );
  return res;
};
